export default "__VITE_ASSET__2a93b83e__"